import React from 'react';
import { BookCheck, Workflow, DollarSign, MapPin, Rocket, Sparkles } from 'lucide-react';
export function WhyPerfect() {
  const points = [{
    title: 'Más de 60 Recetas Probadas y Validadas',
    desc: 'Cada receta fue testeada para garantizar sabor, conservación y rentabilidad. No son recetas de internet. Son recetas que venden.',
    icon: BookCheck,
    accent: 'from-emerald-400 to-emerald-600',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-600'
  }, {
    title: 'Sistema Completo de Principio a Fin',
    desc: 'Desde elegir los ingredientes hasta cobrar por WhatsApp. Todo en un solo recurso, sin tener que buscar nada más.',
    icon: Workflow,
    accent: 'from-teal-400 to-teal-600',
    iconBg: 'bg-teal-100',
    iconColor: 'text-teal-600'
  }, {
    title: 'Precios y Márgenes Incluidos',
    desc: 'Sabés exactamente cuánto te cuesta cada frasco y cuánto cobrar para ganar bien. Sin adivinar. Sin regalar tu trabajo.',
    icon: DollarSign,
    accent: 'from-emerald-500 to-emerald-700',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-600'
  }, {
    title: 'Diseñado para el Mercado Argentino',
    desc: 'Ingredientes accesibles, precios en pesos y Calculadora Anti-Inflación incluida. Funciona aunque los costos cambien cada semana.',
    icon: MapPin,
    accent: 'from-teal-500 to-teal-700',
    iconBg: 'bg-teal-100',
    iconColor: 'text-teal-600'
  }, {
    title: 'Perfecto para Principiantes y para Quien Ya Vende',
    desc: 'Si nunca vendiste nada, el sistema te lleva de cero a tu primer cliente. Si ya vendés, los bonos de condimentos italianos y salsas gourmet te dan el diferencial para cobrar más.',
    icon: Rocket,
    accent: 'from-emerald-400 to-teal-600',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-600'
  }];
  return <section className="py-12 md:py-20 px-4 bg-white relative overflow-hidden" data-id="element-252">
      <div className="absolute top-0 right-0 w-72 h-72 bg-spice-100 rounded-full blur-3xl opacity-50 pointer-events-none" data-id="element-253"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-spice-100 rounded-full blur-3xl opacity-40 pointer-events-none" data-id="element-254"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-255">
        <div className="text-center mb-8 md:mb-16" data-id="element-256">
          <div className="inline-flex items-center gap-2 bg-spice-100 text-spice-700 px-4 py-2 rounded-full text-sm font-bold mb-4 md:mb-6 border border-spice-200" data-id="element-257">
            <Sparkles className="w-4 h-4" data-id="element-258" />
            EL SISTEMA PERFECTO
            <Sparkles className="w-4 h-4" data-id="element-259" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4 md:mb-6 leading-tight" data-id="element-260">
            ¿Qué Hace que la{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-spice-700 via-spice-500 to-spice-700" data-id="element-261">
              BIBLIA DE LOS CONDIMENTOS
            </span>{' '}
            sea un sistema{' '}
            <span className="relative inline-block" data-id="element-262">
              PERFECTO
              <svg className="absolute -bottom-1 left-0 w-full" viewBox="0 0 200 12" fill="none" data-id="element-263">
                <path d="M2 8 C50 2, 150 2, 198 8" stroke="#22C55E" strokeWidth="3" strokeLinecap="round" data-id="element-264" />
              </svg>
            </span>
            ?
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-265">
            Debe ser lo suficientemente completo para no dejarte sin respuestas,
            pero lo suficientemente simple para que cualquier mujer lo aplique
            desde el primer día.
          </p>
        </div>

        <div className="space-y-3 md:space-y-6" data-id="element-266">
          {points.map((point, i) => {
          const Icon = point.icon;
          return <div key={i} className="flex flex-col md:flex-row items-start gap-3 md:gap-5 bg-spice-50 p-4 md:p-8 rounded-2xl border border-spice-100 relative overflow-hidden" data-id="element-267">
                <div className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r ${point.accent}`} data-id="element-268"></div>
                <div className={`${point.iconBg} w-10 h-10 md:w-14 md:h-14 rounded-xl flex items-center justify-center flex-shrink-0`} data-id="element-269">
                  <Icon className={`w-5 h-5 md:w-7 md:h-7 ${point.iconColor}`} data-id="element-270" />
                </div>
                <div data-id="element-271">
                  <div className="flex items-center gap-3 mb-2" data-id="element-272">
                    <span className="text-xs font-bold text-spice-500 bg-spice-100 px-2 py-0.5 rounded-full" data-id="element-273">
                      0{i + 1}
                    </span>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-274">
                      {point.title}
                    </h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed" data-id="element-275">{point.desc}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}